import { createFileRoute } from "@tanstack/react-router";
import { ProjectsPage } from "@/features/food-projects/projects-page";

export const Route = createFileRoute("/food-app/projects/")({
  component: ProjectsPage,
});
